module.exports = __webpack_public_path__ + "media/images/footer_page/sgs_sign-a5c9b8839105542b870ea0ef334dc9c5.png";